'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserId$$anon$136(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$UserId$$anon$136 as $c_Lpresto_types$UserId$$anon$136 };
$p = $c_Lpresto_types$UserId$$anon$136.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserId$$anon$136;
/** @constructor */
function $h_Lpresto_types$UserId$$anon$136() {
}
export { $h_Lpresto_types$UserId$$anon$136 as $h_Lpresto_types$UserId$$anon$136 };
$h_Lpresto_types$UserId$$anon$136.prototype = $p;
$p.bN = (function(str) {
  try {
    var t = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_Long$().ctU(str, 10);
    var t$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f);
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().ak(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.cAf = (function(t) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_RTLong$().ig(t.e, t.f));
});
$p.bJ = (function(t) {
  return this.cAf($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(t));
});
var $d_Lpresto_types$UserId$$anon$136 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserId$$anon$136, "presto.types$UserId$$anon$136", ({
  a32: 1,
  K: 1
}));
export { $d_Lpresto_types$UserId$$anon$136 as $d_Lpresto_types$UserId$$anon$136 };
//# sourceMappingURL=presto.types$-User-Id$$anon$136.js.map
